module.exports = __webpack_public_path__ + "6d66871f20730c71065ec0c77fa00fd6.pdf";